/*
import { 
  _ht, 
  ca,
  cr, 
  a,
  useGblz,
} from 'lib';
*/

import * as ca from "./_ca";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as _ht from './_ht';
import * as _hm from './_hf';

export const atrAbtz = {
  ... ca.atrAbtz,
};

/*
export const barAbtz: _ht.dz = {
  crtCmnz: () => ({i
    boxStlz: a('dw/f fd/ccc pv/0.5'),
  }),

  _ftnz: (pDz: { clr: _ht.s } ) => ({
    boxStlz: a(`dh/4 dw/f fd/rac mb/2 sc/${pDz.clr}6`),
    ctrCz: {
      boxStlz: a('f/1 fd/rcc'),
    },
    bfrCz: {
      boxStlz: a('dp/a dt/0 dl/0 dz/bdy dh/f fd/rsc'),
    },
    atrCz: {
      boxStlz: a('dp/a dt/0 dr/0 dz/bdy dh/f fd/rec'),
    },
  }),
  ftnDntz: () => barAbtz._ftnz({ clr: 'bl' }),
  ftnOrnz: () => barAbtz._ftnz({ clr: 'rd' }),
  ftnStfz: () => barAbtz._ftnz({ clr: 'gn' }),


  _hdrz: (pDz: { ccd: _ht.s } ) => ({
    boxStlz: a(`dh/7 dw/f fd/rac sc/${pDz.ccd}`),
    ctrCz: {
      boxStlz: a('f/1 fd/ccc'),
    },
    bfrCz: {
      boxStlz: a('f/1 fd/rsc'),
    },
    atrCz: {
      boxStlz: a('f/1 fd/rec'),
    },
  }),
  hdrDntz: () => barAbtz._hdrz({ ccd: 'bl7' }),
  hdrOrnz: () => barAbtz._hdrz({ ccd: 'rd7' }),
  hdrStfz: () => barAbtz._hdrz({ ccd: 'gn7' }),

  stfHdgz: () => ({
    boxStlz: a('bc/gn7 bwt/2 dw/f'),
    ctrCz: {
      boxStlz: a('dwn/15 fd/ccc pv/0.5 ph/1 sc/gn7'),
    },
    bfrCz: undefined,
    atrCz: undefined,
  }),

  ... ca.barAbtz,
};
*/
export const boxAbtz = {
  baseAreaz: () => ({
//    boxStlz: a('dw/f dwx/120 mh/a pt/2')
    boxStlz: a('dw/f dwx/120 mh/a')
  }),
  bdyCmnz: () => ({
    boxStlz: a('dw/f f/1 fd/csc'),
  }),
  cttCmnz: () => ({
//    boxStlz: a('dw/f dwx/120 f/1'),
    boxStlz: a('dw/f dwx/s15 f/1 fd/csc ph/1'),
  }),
  topAreaz: () => ({
//    boxStlz: a('bc/lt9 bs/ds bwb/1 dw/f mb/4 pb/2')
    boxStlz: a('dw/f mb/4 pb/2')
  }),
  msgAreaz: () => ({
    boxStlz: a('dw/f mb/2')
  }),
  mainAreaz: () => ({
    boxStlz: a('sc/rd1 br/1 dw/f fd/csc ph/1 pv/2 mb/2')
  }),
  btnAreaz: () => ({
    boxStlz: a('bc/lt9 bd bwv/1 sc/lt1 dw/f fd/rac fw pt/2'),
  }),
  dntSngz: () => ({
    boxStlz: a('dw/f f/1 fd/csc p/1'),
  }),
  stgAreaz: () => ({
    boxStlz: 
      cr.chkDvc() == 'p' ?
        a('dw/f f/1 fd/rac')
      : a('dw/f f/1 fd/cac'),
  }),

  ... ca.boxAbtz,

};

/*
export const brdAbtz = {
  ablz: () => ({
    boxStlz: a('dw/f fd/csc'),
    ttlCz: {
      boxStlz: a('dw/f dwx/60 fd/ccc p/1 sc/rd5'),
      textz: {
        stlz: a('tb tc/lt1 ts/l'),
      },
    },
    dtlCz: {
      boxStlz: a('dw/f dwx/60 pb/1 ph/1 sc/rd5'),
    }
  }),
  cttz: () => ({
    boxStlz: a('dw/f fd/csc'),
    ttlCz: {
      boxStlz: a('dw/f dwx/60 fd/ccc p/1 sc/rd5'),
      textz: {
//        stlz: a('tb tc/rd5 ts/l'),
        stlz: a('tb tc/lt1 ts/l'),
      },
    },
    dtlCz: {
//      boxStlz: a('dw/f dwx/60 p/1'),
      boxStlz: a('bw/2 dw/f dwx/60 p/1 sc/lt1'),
    }
  }),
  msgz: () => ({
    boxStlz: a('dw/f fd/csc'),
    ttlCz: {
      boxStlz: a('dw/f fd/ccc p/2 sc/yw3'),
      textz: {
        stlz: a('ta/c tb ts/l'),
      },
    },
    dtlCz: {
      boxStlz: a('dw/f dwx/80 pb/1 ph/1 sc/lt1'),
    }
  }),
  stgz: () => ({
    boxStlz: a('dw/f fd/csc'),
    ttlCz: {
      boxStlz: a('dw/f dwx/80 fd/ccc p/2 sc/lt3'),
      textz: {
        stlz: a('tb tc/lt9 ts/l'),
      },
    },
    dtlCz: {
      boxStlz: a('dw/f dwx/80 fd/csc p/1 sc/lt3'),
    }
  }),
  wrn1z: () => ({
    boxStlz: a('dw/f fd/csc'),
    ttlCz: {
      boxStlz: a('dw/f dwx/80 fd/ccc pt/1 ph/1 sc/lt1'),
      textz: {
        stlz: a('tb tc/rd5'),
      },
    },
    dtlCz: {
      boxStlz: a('dw/f dwx/80 p/1 sc/lt1'),
    }
  }),
  wrn2z: () => ({
    boxStlz: a('dw/f fd/csc'),
    ttlCz: {
      boxStlz: a('dw/f dwx/80 fd/ccc pv/0.5 ph/1 sc/rd5'),
      textz: {
        stlz: a('tb tc/lt1 ts/l'),
      },
    },
    dtlCz: {
      boxStlz: a('dw/f dwx/80 p/1 sc/lt1'),
    }
  }),

  ... ca.brdAbtz,
};
*/

/*
export const brdV2Abtz = {
};
*/

export const btnAbtz = {

  addDntz: () => ca.btnAbtz._addz({ sc: 'bl6' }),
  addOrnz: () => ca.btnAbtz._addz({ sc: 'rd6' }),
  addStfz: () => ca.btnAbtz._addz({ sc: 'gn6' }),

  backCmnz: () => {
    const _gUserz = gs.useGblz('user');
    return { // staff futter next
      boxStlz: a(`br/1 dh/4 dw/36 fd/ccc sc/${_gUserz.crt.usrClr ? (_gUserz.crt.usrClr + '2') : 't'}`),
      lblCz: {
        textz: {
          stlz: a(`ta/c tb tc/${_gUserz.crt.usrClr ? (_gUserz.crt.usrClr + '7') : 't'} ts/m`)
        }
      },
    }
  },

  cfmDntz: () => ca.btnAbtz._cfmCmnz({ ccd1: 'bl6', ccd2: 'lt1' }),
  cfmOrnz: () => ca.btnAbtz._cfmCmnz({ ccd1: 'rn6', ccd2: 'lt1' }),
  cfmStfz: () => ca.btnAbtz._cfmCmnz({ ccd1: 'gn6', ccd2: 'lt1' }),

  dltCmnz: () => {
    return { // staff futter next
      boxStlz: a(`br/1 dh/4 dw/36 fd/ccc sc/lt3`),
      lblCz: {
        textz: {
          stlz: a(`ta/c tb tc/lt5 ts/m`)
        }
      },
    }
  },
  dltIconz: () => {
    return { // staff futter next
      boxStlz: a(`br/0.5 dw/10 fd/rac mh/a pv/0.5 ph/1 sc/lt3`),
      bfrIconCz: {
        iconPtyz: a(`icc/lt1 icn/trash ics/2`),
      },
      lblCz: {
        textz: {
          pfx: '削除',
          stlz: a(`pl/0.5 ta/c tc/lt1 tb ts/s`),
        }
      },
    }
  },

  fcyz: () => ({ // facility
    boxStlz: a("dh/10 br/1 dh/10 dw/36 fd/ccc sc/lt6"),
    lblCz: {
      textz: {
        stlz: a('tb tc/yw3'),
      }
    }
  }),

  ctdFtnCmnz: () => ca.btnAbtz._ctdz({ br: 2, dw: 7, fd: 'rac', icn: 'search', sc: 't', tc: 'lt1', ts: 's' }),
  ctdFtnStfz: () => ca.btnAbtz._ctdz({ br: 2, dw: 20, pv: 0.5, sc: 'gn6', ts: 's' }),

  holdz: () => ({ // white
    boxStlz: a(" bc/lt5 br/1 bw/2 dh/10 dw/36 fd/ccc mb/2 pv/2 ph/1 sc/lt1"),
    lblCz: {
      textz: {
        stlz: a('ta/c tc/lt5 tb'),
      }
    },
  }),

  homez: () => ({ // green
    boxStlz: a("sc/lm5 dh/10 dw/30 fd/ccc pv/2 mb/2 ph/1 br/1"),
    lblCz: {
      textz: {
        stlz: a('ta/c tc/lt9 tb'),
      }
    }
  }),

  homeDntz: () => ca.btnAbtz._homeCmnz({ ccd: 'bl7' }),
  homeOrnz: () => ca.btnAbtz._homeCmnz({ ccd: 'rd7' }),
  homeStfz: () => ca.btnAbtz._homeCmnz({ ccd: 'gn7', dh: 6, dw: 36 }),

  homeDnt2z: () => ca.btnAbtz._homeCmnz({ ccd: 'bl6' }),
  homeOrn2z: () => ca.btnAbtz._homeCmnz({ ccd: 'rd6' }),
  homeStf2z: () => ca.btnAbtz._homeCmnz({ ccd: 'gn6' }),

  hdrCmnz: () => ({
    boxStlz: a('fd/ccc'),
    lblCz: {
      textz: {
        stlz: a('tc/lt1 ts/s'),
      }
    },
    bfrIconCz: {
      iconPtyz: a('icc/lt1 ics/3'),
    },
  }),

  hdrHomeCmnz: () => ({
    boxStlz: a('fd/ccc'),
    lblCz: {
      textz: {
        pfx: 'メニュー',
        stlz: a('tc/lt1 ts/s'),
      }
    },
    bfrIconCz: {
      iconPtyz: a('icc/lt1 icn/home ics/3'),
    },
  }),

  hdrLgtCmnz: () => ({
    boxStlz: a('fd/ccc'),
    lblCz: {
      textz: {
        pfx: 'ログアウト',
        stlz: a('tc/lt1 ts/s'),
      }
    },
    bfrIconCz: {
      iconPtyz: a('icc/lt1 icn/sign-out ics/3'),
    },
  }),

  nextCmnz: () => {
    const _gUserz = gs.useGblz('user');
    //_hm.l(`ica 322: ${_hm.s(_gUserz.crt.usrClr)}`);
    return { // staff futter next
      boxStlz: a(`br/1 dh/4 dw/36 fd/ccc sc/${_gUserz.crt.usrClr ? (_gUserz.crt.usrClr + '7') : 't'}`),
      lblCz: {
        textz: {
          stlz: a(`ta/c tb tc/lt1 ts/m`)
        }
      },
    }
  },

  rndDntz: () => ca.btnAbtz._ctdCmnz({ sc: 'lm5', tc: 'lt9', br: 10, dh: 4,  dw: 27}),

  stfDrawz: () => ({ // staff draw
    boxStlz: a("br/3 dw/16 fd/ccc pv/0.5 sc/gn7"),
    lblCz: {
      textz: {
        stlz: a('tb tc/lt1 ts/m'),
    }
    }
  }),

  stfNmlz: () => ({ // confirm
    boxStlz: a("br/0.5 dw/9 fd/rac pv/0.5 ph/1 sc/gn7"),
    lblCz: {
      textz: {
        stlz: a('ta/c tc/lt1 tb'),
      }
    },
    bfrIconCz: {
      iconPtyz: a('icc/lt1 ics/2.5'),
    }
  }),

  stgz: () => ({ // setting
    boxStlz: a("br/1 dh/10 dw/36 fd/ccc sc/lt6 "),
    lblCz: {
      textz: {
        stlz: a('ta/c tc/lt1 tb'),
      }
    }
  }),
  sttz: () => ({ // status
    boxStlz: a("dh/10 br/1 dh/10 dw/36 fd/ccc sc/lt6"),
    lblCz: {
      textz: {
        stlz: a('ta/c tc/lt1 tb'),
      }
    }
  }),
  ... ca.btnAbtz,

};

export const cbxAbtz = {
  cfmz: () => ({
    boxStlz: a("br/1 dw/f fd/rsc pv/2 ph/3"),
    cbxCz: {
      boxStlz: {
        sctz: a("dh/3 dw/3"),
        nmlz: a("dh/3 dw/3"),
      },
      iconPtyz: {
        sctz: a("icc/lt1 icn/check-square-o ics/3"),
        nmlz: a("icc/lt1 icn/square-o ics/3"),
      },
    },
    lblCz: {
      boxStlz: {},
      textz: {
//        stlz: a("dh/3 tb tc/lt1 ts/l pl/0.5"),
        stlz: a("tb tc/lt1 ts/l pl/0.5"),
        ptyz: a('tn/10'),
      },
    },
  }),

  ... ca.cbxAbtz,
};

export const cbxMmAbtz: _ht.dz = {
  ... ca.cbxMmAbtz,
};

export const cdrAbtz: _ht.dz = {
  ... ca.cdrAbtz,
};

export const ennAbtz = {
  ... ca.ennAbtz,
};

export const fldAbtz = {
  leftLinez: () => ({
    boxStlz: 
      cr.chkDvc() == 'p' ?
        a("bc/rd5 bwl/6 dw/58 fd/css pv/0.5 ph/1")
      : a("bc/rd5 bwl/6 dw/38 fd/css pv/0.5 ph/1"),
    mainz: {
      boxStlz: 
        cr.chkDvc() == 'p' ?
          a("dw/f fd/rss")
        : a("dw/f fd/css"),
      lblCz: {
        boxStlz: a('dw/15 fd/rsc pt/0.5'),
        textz: {
          stlz: a('tb'),
        },
      },
    },
    subz: {
      boxStlz: a('dw/f mt/1'),
      msgCz: {
        boxStlz: a('dw/f'),
        textz: {
          stlz: a("tb tc/yw5 ts/s"),
        },
      },
    },
  }),

/*
  stfRsv2az: () => ({
    boxStlz: a('dw/f ph/1'),
    mainz: {
      boxStlz: a('dw/f fd/rsc'),
      lblCz: {
        boxStlz: a('dw/12'),
        textz: {
          stlz: a('tb tc/gn7'),
        }
      }
    },
  }),
*/

  stfRsv2b1z: () => ({
    boxStlz: a('dw/f ph/1'),
    mainz: {
      boxStlz: a('dw/f fd/rsc'),
      lblCz: {
        boxStlz: a('dw/12'),
        textz: {
          stlz: a('tb tc/gn7'),
        }
      }
    },
  }),

  stfRsv2b2z: () => ({
    boxStlz: a('dh/f dw/f ph/1'),
    mainz: {
      boxStlz: a('dh/f dw/f fd/ccc'),
      lblCz: {
        boxStlz: a('f/1 fd/ccc'),
        textz: {
          stlz: a('ta/c tb tc/gn7'),
        }
      }
    },
  }),

  stfSchz: () => ({
    boxStlz: a('pr/1'),
    mainz: {
      boxStlz: a('fd/rsc'),
      lblCz: {
        boxStlz: {},
        textz: {
          stlz: a('tb tc/lt1 ts/s'),
        }
      }
    },
  }),

  stgz: () => ({
    boxStlz: 
      cr.chkDvc() == 'p' ?
        a("dw/76 fd/css pb/1")
      : a("dw/38 fd/css pv/0.5 ph/1"),
    mainz: {
      boxStlz: 
        cr.chkDvc() == 'p' ?
          a("dw/f fd/rsc")
        : a("dw/f fd/css"),
      lblCz: {
        boxStlz: 
          cr.chkDvc() == 'p' ?
            a('dw/40 fd/rec')
          : a('dw/40 fd/rsc'),
        textz: {
          stlz: a('tb'),
        },
      },
    },
    subz: {
      boxStlz: a('dw/f mt/0.5'),
      msgCz: {
        boxStlz: a('dw/f fd/rec'),
        textz: {
          stlz: a("tb tc/yw7 ts/s"),
        },
      },
    },
  }),

  ... ca.fldAbtz,

};

export const iconAbtz = {
  ... ca.iconAbtz,
};

export const iptAbtz = {
/*
  ftnCmnz: () => ({
    iptStlz: a("bc/lt3 br/0.5 bw/1 dw/f sc/t tc/lt1 ts/m pv/0.5 ph/1 ioc/lt4"),
  }),
*/
//  ftnCmnz: () => ca.iptAbtz._oldz(),
  ftnCmnz: () => ca.iptAbtz._oldz({ bc: 'lt9', tc: 'lt9' }),

  stgz: () => ({
    iptStlz: {
      editz: a("bc/lt3 br/1 bw/2 dh/4 dw/f sc/lt1 tc/lt9 ts/m p/1 ioc/lt4"),
      showz: a("dh/f dw/f fd/rsc sc/t tc/lt9 ts/m ph/1"),
    },
  }),

  mlnCmnz: () => ({ // multiline
    iptStlz: {
      editz: a("sc/lt1 dh/20 dw/f bc/lt3 br/1 bw/2 tc/lt9 ts/m p/1 ioc/lt4"),
      showz: a("sc/t dh/20 dw/f bc/t bw/2 tc/lt9 ts/m p/1"),
    },
    iptPtyz: {
      multiline: true,
    }
  }),

  ... ca.iptAbtz,

} as _ht.dz;

export const iptMplAbtz: _ht.dz = {
  ... ca.iptMplAbtz,
};

export const lblAbtz = {

  ftnCmnz: () => ({
    boxStlz: a('dw/40 fd/rsc pr/1'),
    lblCz: {
      boxStlz: a('pr/1'),
      textz: {
//        stlz: a('tb tc/lt1 ts/s')
        stlz: a('tb tc/lt9 ts/s')
      },
    },
    cttCz: {
      boxStlz: a('f/1'),
    },
  }),

  bandAltCmnz: () => ca.lblAbtz._bandz({ sc: 'rd5' }),

  barHdrCmnz: () => ca.lblAbtz._barz({ bc: 'lt7', bwb: 3, tc: 'lt7' }),
  barHdrStfz: () => ca.lblAbtz._barz({ bc: 'gn7', bwb: 3, tc: 'lt7' }),

  bandLeftStfz: () => ca.lblAbtz._bandz({ sc: 'gn7', fd: 'rsc' }),
  bandCtrStfz: () => ca.lblAbtz._bandz({ sc: 'gn7', fd: 'rcc' }),

  ctdBrdStfz: () => ca.lblAbtz._ctdz({ ccd1: 'gn7', ccd2: 'lt1' }),

  hzlDntz: () => ca.lblAbtz._hzlz({ tc: 'bl7' }),
  hzlOrnz: () => ca.lblAbtz._hzlz({ tc: 'rd7' }),
  hzlStfz: () => ca.lblAbtz._hzlz({ tc: 'gn7' }),
  hzlMplStfz: () => ca.lblAbtz._hzlz({ tc: 'gn7', bMpl: true }),

  vclDntz: () => ca.lblAbtz._vclz({ tc: 'bl7' }),
  vclOrnz: () => ca.lblAbtz._vclz({ tc: 'rd7' }),
  vclStfz: () => ca.lblAbtz._vclz({ tc: 'gn7' }),

  lineLeftDntz: () => ({
    boxStlz: a('dw/40 fd/rsc pr/1'),
    lblCz: {
      boxStlz: a('pr/1'),
      textz: {
        stlz: a('tb tc/lt1 ts/s')
      },
    },
    cttCz: {
      boxStlz: a('f/1'),
    },
  }),

  ... ca.lblAbtz,

};
/*
export const lineAbtz = {
  nolineCmnz: () => ({
    boxStlz: a('dw/f fd/css pt/1'),
    cellCz: ( _nIdx: _ht.n ) => ({
      boxStlz: a('dw/f fd/rss mb/1'),
    })
  }),

  nolineVclCmnz: () => ({
    boxStlz: a('dw/f fd/css'),
    cellCz: ( _nIdx: _ht.n ) => ({
      boxStlz: a('dw/f fd/rss mb/1'),
    })
  }),

  nolineHzlCmnz: () => ({
    boxStlz: a('dw/f fd/rsc pt/1'),
    cellCz: ( _nIdx: _ht.n ) => ({
      boxStlz: a('f/1 fd/ccc mb/1'),
    })
  }),

  ... ca.lineAbtz,
};
*/

export const linkAbtz = {
  cbxz: () => ({
    boxStlz: a("fd/rss"),
    linkCz: {
      boxStlz: {},
      textz: {
        stlz: a("tb tc/bl7 tu"),
      }
    },
    bfrCz: {
      boxStlz: a("pr/1"),
      textz: {
        stlz: {},
      },
    },
    atrCz: {
      boxStlz: a("pl/1"),
      textz: {
        stlz: {},
      },
    },
  }),
} as _ht.dz;

export const listAbtz: _ht.dz = {
  fcyz: () => ({
    boxStlz: 
      cr.chkDvc() == 'p' ?
        a('pl/1 pv/1')
      : a('dw/f fd/csc pt/1'),
    btnCz: {
      boxStlz: {
        nmlz: 
          cr.chkDvc() == 'p' ?
            a("bc/rd5 bwb/4 fd/ccc mr/1 p/1 sc/rd3")
          : a("bc/rd5 bwb/4 dw/36 fd/ccc mb/1 p/1 sc/rd3"),
        sctz: 
          cr.chkDvc() == 'p' ?
            a("bc/rd5 bw/0 bwb/4 fd/ccc p/1 mr/1 sc/rd3")
          : a("bc/rd5 bwb/4 dw/36 fd/ccc mb/1 p/1 sc/rd3"),
      },
      lblCz: {
        boxStlz: {
          nmlz: 
            cr.chkDvc() == 'p' ?
              a('dw/f')
            : a('dw/f'),
          sctz: 
            cr.chkDvc() == 'p' ?
              a('dw/f')
            : a('dw/f'),
        },
        textz: {
          stlz: {
            nmlz: 
              cr.chkDvc() == 'p' ?
                a("tb tc/lt9 ts/l")
              : a("tb tc/lt9 ts/l"),
            sctz: 
              cr.chkDvc() == 'p' ?
                a("tb tc/lt9 ts/l")
              : a("tb tc/lt9 ts/l"),
          },
        },
      },
      bfrIconCz: {
        iconPtyz: {},
        boxStlz: {},
      },
      atrIconCz: {
        iconPtyz: {},
        boxStlz: {},
      },
    },
  }),
};

export const msgAbtz = {
  ctrz: () => ({
    boxStlz: a("sc/lt1 dw/f fd/ccc"),
    lz: {
      boxStlz: a("fd/rss pb/0.5"),
      mkrCz: {
        boxStlz: a("dw/2 fd/ccc"),
        textz: {
          stlz: a("ts/m"),
          ptyz: a("tn/10"),
        },
      },
      msgCz: {
        boxStlz: a("f/1"),
        textz: {
          stlz: a("ts/m fw/w"),
          ptyz: a("tn/10"),
        },
      },
    },
  }),
  cttz: () => ({ // content
    boxStlz: a("dw/f"),
    lz: {
      boxStlz: a("fd/rss pb/0.5"),
      mkrCz: {
        boxStlz: a("dw/14 fd/rsc"),
        textz: {
          stlz: a("tb tc/lt9 ts/m"),
          ptyz: a("tn/10"),
        },
      },
      msgCz: {
        boxStlz: a("f/1"),
        textz: {
          stlz: a("tb tc/lt9 ts/m fw/w"),
          ptyz: a("tn/10"),
        },
      },
    },
  }),
  listz: () => ({
    boxStlz: a("sc/lt1 dw/f"),
    lz: {
      boxStlz: a("fd/rss pb/0.5"),
      mkrCz: {
        boxStlz: a("dw/2 fd/ccc"),
        textz: {
          stlz: a("ts/2"),
          ptyz: a("tn/10"),
        },
      },
      msgCz: {
        boxStlz: a("f/1"),
        textz: {
          stlz: a("ts/2 fw/w"),
          ptyz: a("tn/10"),
        },
      },
    },
  }),

  lgn1Cmnz: () => ({
    boxStlz: a('dw/f dwx/100'),
    lz: {
      boxStlz: a('fd/rsc mb/1'),
      mkrCz: {
        boxStlz: a('dh/f dw/2 fd/css'),
        textz: {
          stlz: undefined,
        },
      },
      msgCz: {
        boxStlz: a('f/1 pl/0.5'),
        textz: {
          stlz: undefined,
        },
      },
    },
  }),

  lgn2Cmnz: () => ({
    boxStlz: a('dw/f dwx/100'),
    lz: {
      boxStlz: a('fd/rsc mb/1'),
      mkrCz: {
        boxStlz: a('dh/f dw/2 fd/css'),
        textz: {
          stlz: a('ts/s'),
        },
      },
      msgCz: {
        boxStlz: a('f/1 pl/0.5'),
        textz: {
          stlz: a('ts/s'),
        },
      },
    },
  }),

  ornCmnz: () => ca.msgAbtz._leftBdrCmnz({ ccd: 'lt9', bdrW: 4 }),

  wrn1z: () => ({
    boxStlz: a("sc/lt1 dw/f"),
    lz: {
      boxStlz: a("fd/rss pb/0.5"),
      mkrCz: {
        boxStlz: a("dw/2 fd/ccc"),
        textz: {
          stlz: a("ts/2"),
          ptyz: a("tn/10"),
        },
      },
      msgCz: {
        boxStlz: a("f/1"),
        textz: {
          stlz: a("ts/2 fw/w"),
          ptyz: a("tn/10"),
        },
      },
    },
  }),
  wrn2z: () => ({
    boxStlz: a("sc/lt1 dw/f"),
    lz: {
      boxStlz: a("fd/rss pb/0.5"),
      mkrCz: {
        boxStlz: a("dw/2 fd/ccc"),
        textz: {
          stlz: a("tb tc/rd5 ts/2"),
          ptyz: a("tn/10"),
        },
      },
      msgCz: {
        boxStlz: a("f/1"),
        textz: {
          stlz: a("tb tc/rd5 ts/2 fw/w"),
          ptyz: a("tn/10"),
        },
      },
    },
  }),

  ... ca.msgAbtz,

};

export const gridAbtz: _ht.dz = {

  nmlz: () => ({
    boxStlz: a('bc/gn7 bwb/2 dw/f fd/css ph/1'),
    lz: ( _nRowIdx: _ht.n ) => ({
      boxStlz:
        _nRowIdx == 0 ? 
          a('bc/gn7 bwb/2 dw/f fd/rsc mb/1')
        : a('fd/rss dw/f fd/rsc mb/1'),
      cellz: ( _nCellIdx: _ht.n ) => ({
        boxStlz:
          _nCellIdx == 0 ? 
            a('fd/rsc f/6 pr/1')
          : _nCellIdx == 1 ? 
            a('fd/rsc f/12 pr/1')
          : _nCellIdx == 2 ? 
            a('fd/rsc f/26 pr/1')
          : _nCellIdx == 3 ? 
            a('fd/rsc f/14 pr/1')
          : _nCellIdx == 4 ? 
            a('fd/rsc f/26 pr/1')
          : _nCellIdx == 5 ? 
            a('fd/rsc f/12 pr/1')
          : _nCellIdx == 6 ? 
            a('fd/rec f/8')
          : _nCellIdx == 7 ? 
            a('fd/rec f/16')
          : {},
      })
    })
  }),

  barBtnViewCmnz: () => ca.gridAbtz._barz({ fd: 'rac', pv: 2, sc: 't' }),
  barBtnFtnCmnz: () => ca.gridAbtz._barz({ fd: 'rbc', pv: 1, sc: 't' }),

//  barFtnStfz: () => ca.gridAbtz._barz({ dh: 4.5, dw: 'f', fd: 'rbc', pv: 0.5, sc: 'gn6'}),
  barFtnStfz: () => ca.gridAbtz._barz({ dh: 4.5, dw: 'f', fd: 'rbc', pv: 0.5, sc: 'lm1'}),
  barFtnOrnz: () => ca.gridAbtz._barz({ dh: 4.5, dw: 'f', fd: 'rbc', pv: 0.5, sc: 'rd6'}),

/*
  barHdrDntz: () => ca.gridAbtz._barz({ fd:'rbc', sc: 'bl7', pv: 0.5}),
  barHdrStfz: () => ca.gridAbtz._barz({ fd:'rbc', sc: 'gn7', pv: 0.5}),
  barHdrOrnz: () => ca.gridAbtz._barz({ fd:'rbc', sc: 'rd7', pv: 0.5}),
*/
  barHdrCmnz: () => ca.gridAbtz._barz({ fd:'rbc', sc: 'lt7', pv: 0.5}),

  brdAltz: () => ca.gridAbtz._brdz({ ccd1: 'rd5', ccd2: 'rd5', ccd3: 'rd5' }), // alert
  brdWngz: () => ca.gridAbtz._brdz({ ccd1: 'rd5', ccd2: 'lt1', ccd3: 'rd5' }), // warning
  brdMsgz: () => ca.gridAbtz._brdz({ ccd1: 't', ccd2: 't', ccd3: 't' }), // warning

  brdDntz: () => ca.gridAbtz._brdz({ ccd1: 'gn5', ccd2: 'gn5', ccd3: 'gn5' }), // alert

  cmnAbyz: () => ({
    boxStlz: a('bc/lt5 bwr/1 bwt/1 dw/f fd/css'),
    lineCz: ( _nRowIdx: _ht.n ) => ({
      boxStlz: a('fd/rss dw/f fd/rsc'),
      cellCz: ( _nCellIdx: _ht.n ) => ({
        boxStlz:
          _nCellIdx == 0 ? 
            a('bc/lt5 bwl/1 bwb/1 dh/f fd/rsc f/3 pl/1')
          : a('bc/lt5 bwl/1 bwb/1 dh/f fd/ccc f/1'),
      })
    })
  }),

  dntSngz: () => ({ // dantai signage
    boxStlz: a('bc/bl7 bwb/4 dw/f f/1 fd/csc'),
    lineCz: ( _nLineIdx: _ht.n ) => ({
      boxStlz:
        _nLineIdx == 0 ? 
          a('bc/bl7 bwb/4 dw/f f/1 fd/rsc')
        : _nLineIdx == 1 ? 
          a('dw/f f/1 fd/rsc')
        : a('bc/bl7 bs/dt bwt/2 dw/f f/1 fd/rsc'),
      cellCz: ( _nCellIdx: _ht.n ) => ({
        boxStlz: 
          _nLineIdx == 0 ?
            _nCellIdx == 0 ?
              a('fd/rcc f/1')
            : a('bc/bl7 bs/dt bwl/2 dh/f fd/rcc f/1 ph/1')
          :
            _nCellIdx == 0 ?
              a('fd/rcc f/1')
            : a('bc/bl7 bs/dt bwl/2 dh/f fd/rsc f/1 ph/1')
      })
    })
  }),

  ftrBarCmnz: () => ({
    boxStlz: a(`dw/f fd/ccc`),
    lineCz: ( _nLineIdx: _ht.n ) => ({
      boxStlz: undefined,
      cellCz: ( _nCellIdx: _ht.n ) => ({
        boxStlz: undefined
      })
    })
  }),

  hdrDntz: () => ca.gridAbtz._tblHdrz({ bc: 'bl7' }),
  hdrOrnz: () => ca.gridAbtz._tblHdrz({ bc: 'rd7' }),
  hdrStfz: () => ca.gridAbtz._tblHdrz({ bc: 'gn7' }),

  lgnCmnz: () => ({
    boxStlz: a(`dw/f f/1 fd/cac`),
    lineCz: ( _nLineIdx: _ht.n ) => ({
      boxStlz: a(`f/1 fd/cac`),
      cellCz: ( _nCellIdx: _ht.n ) => ({
        boxStlz: undefined
      })
    })
  }),

  lineDntz: () => ca.gridAbtz._tblBdyz({ bc: 'bl7', bw: 2, mb: 0.5, ph: 1.0 }),
  lineOrnz: () => ca.gridAbtz._tblBdyz({ bc: 'rd7', bw: 2, mb: 0.5, ph: 1.0 }),
  lineStfz: () => ca.gridAbtz._tblBdyz({ bc: 'gn7', bw: 2, mb: 0.5, ph: 1.0 }),

//  nolineCmnz: () => ca.gridAbtz._tblBdyz({ bc: 't' }),
  nolineCmnz: () => ca.gridAbtz._tblBdyz({ bc: 't', bw: 2, mb: 0.0, ph: 0.0 }),

  stfBkgz: () => ({ // staff booking
    boxStlz: a('bc/gn7 bwb/2 dw/f dwx/100 fd/csc'),
    lz: ( _nLineIdx: _ht.n ) => ({
      boxStlz:
        _nLineIdx == 0 ? 
          a('bc/gn7 bwb/2 dw/f fd/rsc mb/1')
        : a('dw/f fd/rsc mb/1'),
      cellz: ( _nCellIdx: _ht.n ) => ({
        boxStlz: a('fd/css f/1')
      })
    })
  }),
  stfDrawz: () => ({ // staff draw
    boxStlz: a('bc/gn7 bwb/2 dw/f dwx/100 fd/csc'),
    lz: ( _nLineIdx: _ht.n ) => ({
      boxStlz:
        _nLineIdx == 0 ? 
          a('bc/gn7 bwb/2 dw/f fd/rsc mb/1')
        : a('dw/f fd/rsc mb/1'),
      cellz: ( _nCellIdx: _ht.n ) => ({
        boxStlz: a('fd/rsc f/1')
      })
    })
  }),

  stfListz: () => ({ // staff 
    boxStlz: a('dw/f'),
    lz: ( _nLineIdx: _ht.n ) => ({
      boxStlz:
          a('dw/f f/1 fd/rsc mb/1'),
      cellz: ( _nCellIdx: _ht.n ) => ({
        boxStlz: a('f/1')
      })
    })
  }),
  stfRsv1z: () => ({ // staff reserve #1
    boxStlz: a('dw/f'),
    lz: ( _nRowIdx: _ht.n ) => ({
      boxStlz:
        _nRowIdx == 0 ? 
          a('dw/f fd/rsc sc/gn6')
        : a('dw/f fd/rsc'),
      cellz: ( _nCellIdx: _ht.n ) => ({
        boxStlz:
          _nCellIdx == 0 ? 
            a('fd/rsc f/3 pr/1')
          : _nCellIdx == 1 ? 
            a('fd/rsc f/2 pr/1')
          : _nCellIdx == 2 ? 
            a('fd/rsc f/3 pr/1')
          : _nCellIdx == 3 ? 
            a('fd/rsc f/1 pr/1')
          : _nCellIdx == 4 ? 
            a('fd/rsc f/1 pr/1')
          : {},
      })
    })
  }),
  stfRsv2bz: () => ({ // staff reserve #2
    boxStlz: a('dw/f'),
    lz: ( _nRowIdx: _ht.n ) => ({
      boxStlz: a('dw/f fd/rsc'),
      cellz: ( _nCellIdx: _ht.n ) => ({
        boxStlz:
          _nRowIdx == 0 ?
            _nCellIdx == 0 ? 
              a('fd/rsc f/1')
            : _nCellIdx == 1 ? 
              a('fd/rsc f/4.5')
            : _nCellIdx == 2 ? 
              a('fd/rsc f/4.5')
            : _nCellIdx == 3 ? 
              a('fd/rsc f/1')
            : {}
          : _nRowIdx == 1 ?
            _nCellIdx == 0 ? 
              a('dh/f fd/rsc f/1')
            : (_nCellIdx >= 1 && _nCellIdx <= 5) ? 
              a('dh/f fd/rsc f/1')
            : (_nCellIdx >= 6 && _nCellIdx <= 7) ? 
              a('dh/f fd/rsc f/2')
            : _nCellIdx == 8 ? 
              a('dh/f fd/rsc f/1')
            : {}
          : _nRowIdx == 2 ?
            _nCellIdx == 0 ? 
              a('fd/rsc f/1')
            : (_nCellIdx >= 1 && _nCellIdx <= 3) ? 
              a('fd/rsc f/3')
            : _nCellIdx == 4 ? 
              a('fd/rsc f/1')
            : {}
          : {},
      })
    })
  }),
  stfZonez: () => ({
    boxStlz: a('bc/gn7 bwb/2 dw/f'),
    lz: ( _nLineIdx: _ht.n ) => ({
      boxStlz: 
        _nLineIdx == 0 ?
          a('bc/gn7 bwb/2 dw/f fd/rsc pv/0.5')
        : _nLineIdx == 1 ?
          a('dw/f fd/rsc')
        : a('bc/gn7 bs/dt bwt/1 dw/f fd/rsc pv/0.5'),
      cellz: ( _nCellIdx: _ht.n ) => ({
        boxStlz:
          _nCellIdx == 0 ? 
            a('dh/f f/1 fd/cac')
          : a('dh/f f/1 fd/cac'),
      })
    })
  }),

/*
  viewHdrStfz: () => ({
    boxStlz: a('dw/f sc/gn7'),
    lineCz: ( _nLineIdx: _ht.n ) => ({
      boxStlz: 
        a('dw/f fd/rbc'),
      cellCz: ( _nCellIdx: _ht.n ) => ({
        boxStlz:
          a('fd/rsc')
      })
    })
  }),
*/
  vclCmnz: () => ca.gridAbtz._vclz({dw:'f'}),

  ... ca.gridAbtz,

};

export const pnnAbtz: _ht.dz = {
  ... ca.pnnAbtz,
};

export const rootAbtz: _ht.dz = {
  dtpCmnz: () => ca.rootAbtz._dtpCmnz({ ccd: 'lt1' }),
  ... ca.rootAbtz,
};

export const sprAbtz: _ht.dz = {
  ... ca.sprAbtz,
};

export const srlAbtz = {
  stfCttz: () => ({
    srlStlz: {
      otrz: a("dw/f dwx/120 f/1"),
      inrz: a("fd/csc"),
    },
    srlPtyz: {},
  }),

  cttCmnz: () => ({
    srlStlz: {
//      otrz: a('dw/f dwx/120 f/1'),
//      inrz: a('fd/csc'),
//      otrz: a('dw/f dwx/120 f/1 mh/a'),
//      otrz: a('dw/f dwx/120 f/1 mh/a'),
      otrz: a('dw/f dwx/s15 f/1 mh/a'),
      inrz: a('dw/f fd/csc'),
    },
    srlPtyz: undefined,
  }),

  ... ca.srlAbtz,

};

export const tblAbtz = {
  ... ca.tblAbtz,
  cttStfz: () => ({
    srlCz: {
      abtType: 'cttCmnz',
    },
    boxCz: {
      abtType: 'cttCmnz',
    },
    hdrCz: {
      abtType: 'hdrStfz',
    },
    bdyCz: {
      abtType: 'lineStfz',
    }
  })
};

export const textAbtz = {
  crtCmnz: () => ({
    boxStlz: {},
    textz: {  
      stlz: a("ts/xs"),
    },
  }),
  cmnLinkz: () => ({ // common link
    boxStlz: {},
    textz: {  
      stlz: a('tb tc/yw5 tu'),
    },
  }),
  dntSngBdyz: () => ({
    boxStlz: {},
    textz: {
      stlz: a('tb ts/4'),
    },
  }),
  dntSngHdrz: () => ({
    boxStlz: {},
    textz: {
      stlz: a('tb ts/4'),
    },
  }),
  dntSngPageNamez: () => ({
    boxStlz: {},
    textz: {
      stlz: a('tb tc/lt1 ts/4'),
    },
  }),

  ftnCmnz: () => ({
    boxStlz: a('mr/2'),
    textz: {  
      pfx: '絞り込み:',
      stlz: a('tb ts/s'),
    },
  }),

  hdrCmnz: () => ({ // staff header right
    boxStlz: {},
    textz: {  
      stlz: a('tb tc/lt1 ts/s'),
    },
  }),

  hdrPageNameCmnz: () => ({
    boxStlz: {},
    textz: {  
      stlz: a("tb tc/lt1 ts/l"),
    },
  }),

  lblDntz: () => ca.textAbtz._lblz({tc: 'bl7'}),
  lblOrnz: () => ca.textAbtz._lblz({tc: 'rd7'}),
  lblStfz: () => ca.textAbtz._lblz({tc: 'gn7'}),

  lgnHdgDntz: () => ca.textAbtz._lgnHdgCmnz({ ccd: 'bl7' }),
  lgnHdgOrnz: () => ca.textAbtz._lgnHdgCmnz({ ccd: 'rd7' }),
  lgnHdgStfz: () => ca.textAbtz._lgnHdgCmnz({ ccd: 'gn7' }),

/*
  lgnMsgDntz: () => ({
    boxStlz: a('bc/lt3 br/1 bw/2 dw/f dw/100 mh/a sc/rd1'),
    textz: {  
      stlz: undefined,
    },
  }),
*/

  rmkCmnz: () => ca.textAbtz._rmkz({ tc: 'rd5' }),

  stfHdgz: () => ({
    boxStlz: undefined,
    textz: {
      stlz: a('tb tc/lt1 ts/m'),
    },
  }),
  stfRsvHdrz: () => ({
    boxStlz: {},
    textz: {  
      stlz: a('tb tc/lt1 ts/m'),
    },
  }),
  stfTblEnnz: () => ({ // staff table explanation
    boxStlz: a('pr/1'),
    textz: {  
      stlz: a('tc/lt9 ts/s'),
      ptyz: a('tn/1'),
    },
  }),
  msgz: () => ({ // warning #2
    boxStlz: a("dw/f fd/ccc"),
    textz: {  
      stlz: a("tb tc/lt9 ts/l"),
    },
  }),
  wrn2z: () => ({ // warning #2
    boxStlz: a("dw/f fd/ccc"),
    textz: {  
      stlz: a("ta/c tb tc/rd5 ts/l"),
    },
  }),

  altCmnz: () => ca.textAbtz._tagCmnz({}),

  ... ca.textAbtz,
} as _ht.dz;

export const viewListAbtz: _ht.dz = {
  ... ca.viewListAbtz,
  nmlz: () => ({
    tblCz: {
      abtType: 'cttStfz',
    },
    hdrCz: {
      textCz: {
        abtType: 'lblStfz',
      }
    },
    bdyCz: {
      btnCz: {
        abtType: 'cfmStfz',
      }
    }
  }),
};

export const viewDtlAbtz: _ht.dz = {
  ... ca.viewDtlAbtz,
  nmlz: () => ({
    crtz: {
      lblCz: {
        abtType: 'hzlStfz',
      }
    },
    cldz: {
      tblCz: {
        abtType: 'cttStfz',
      },
      hdrCz: {
        textCz: {
          abtType: 'lblStfz',
        }
      },
      bdyCz: {
        btnDltCz: {
//          abtType: 'dltStfz',
          abtType: 'dltIconz',
        },
        btnAddCz: {
          abtType: 'addStfz',
        }
      }
    },
  }),
};

export const wireAbtz: _ht.dz = {
  ... ca.wireAbtz,
};
